/**
 * Review entity — a customer's rating + comment on a completed order's product.
 *
 * Mirrors the backend ``ReviewSerializer`` (read shape) and the review-create input.
 * Reviews are bound to a user, an order and a product (ТЗ §9); only visible reviews are
 * ever returned by the API, and the product's ``rating_avg`` / ``reviews_count`` are
 * server-denormalised from them.
 */

/** Public read representation of a visible review (``GET /api/products/<id>/reviews/``). */
export interface Review {
  readonly id: number;
  /** Legacy single product FK; ``null`` for order-level reviews (kept for compat). */
  readonly product: number | null;
  /** Product ids the review applies to (resolved from the order's items; дельта §2). */
  readonly products: readonly number[];
  readonly order: number;
  /** Integer 1–5. */
  readonly rating: number;
  readonly text: string;
  readonly author_name: string;
  /** Author avatar URL (may be empty; render with a fallback; дельта §2). */
  readonly author_avatar_url: string;
  readonly is_pinned: boolean;
  readonly shop_reply: string;
  /** ISO-8601 timestamp of when the review was left. */
  readonly created_at: string;
}

/** Body for ``POST /api/orders/<id>/review/`` (product/order come from the URL). */
export interface ReviewInput {
  /** Integer 1–5. */
  readonly rating: number;
  readonly text?: string;
}

/** Lowest / highest allowed star rating (matches the server's validation). */
export const MIN_RATING = 1;
export const MAX_RATING = 5;
